import { environment } from "../environment";
import { Book, PayloadBook } from "../models/books";
import { AsyncResult } from "../models/common/async-result";
import api from "./api";

export async function getBook(bookId: number): Promise<Book> {
  const baseUrl = environment.api.book.get
  const url = baseUrl
    .replace('{bookId}', String(bookId));

  return await api.get(url).then(res => res.data.success)
}

export type filterType = 'intitle' | 'inauthor' | 'inpublisher' | 'isbn'

export async function getAllBookFromGoogle(search: string, type: filterType = 'intitle', page: number = 0): Promise<Book[]> {
  const baseUrl = environment.api.book.listByGoogle

  const url = baseUrl
    .replace('{type}', String(type))
    .replace('{search}', String(search))
    .replace('{page}', String(page));

  return await api.get(url)
    .then(res => res.data.success)
}

export async function createBook(payload: PayloadBook & Book): Promise<AsyncResult<Book>> {
  let baseUrl = environment.api.book.create

  delete payload.file
  delete payload.genres

  return await api.post(baseUrl, payload)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function createBookByGoogleId(googleId: string): Promise<AsyncResult<Book>> {
  const baseUrl = environment.api.book.createBookByGoogleId

  const url = baseUrl
    .replace('{googleId}', String(googleId))

  return await api.post(url)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function getBookByGoogleId(googleId: string): Promise<AsyncResult<Book>> {
  const baseUrl = environment.api.book.getByGoogleId

  const url = baseUrl
    .replace('{googleId}', googleId)

  return await api.get(url)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } })
}

export async function getFromGoogleId(googleId: string): Promise<Book> {
  const baseUrl = environment.api.book.getFromGoogleId

  const url = baseUrl
    .replace('{googleId}', googleId)

  return await api.get(url).then(res => res.data?.success)
}


